<form [formGroup]="redefinirSenhaForm" (submit)="redefinirSenha()" class="form">
  <h2>Redefinir senha</h2>
  <p>Digite o email para o qual deseja redefinir a senha</p>
  <div class="row my-4">
    <div class="col">
      <label>E-mail:</label>
      <input formControlName="email" class="input form-control" type="email" name="email" placeholder="nome@email.com">
    </div>
    <div class="message-error"
      *ngIf="redefinirSenhaForm.get('email')?.errors?.required && redefinirSenhaForm.get('email')?.touched">
      Campo Obrigatório
    </div>
    <div class="message-error"
      *ngIf="redefinirSenhaForm.get('email')?.errors?.email&& redefinirSenhaForm.get('email')?.touched">
      Formato Inválido
    </div>
  </div>
  <div class="row my-5">
    <div class="col">
      <div>
        <button class="form-button button-primary" [disabled]="!redefinirSenhaForm.valid">Enviar
          email</button>
      </div>
    </div>
  </div>
</form>